import React from 'react';
import {CoreText} from '@anywhere-expert/base-ui';

export default ({children}: {children: string}) => (
    <CoreText textType="primary" size="m" weight="bold">
        {children}
    </CoreText>
);
